import { VisualFieldMatrix } from '../../../2022-component-library';
import { Legend } from '../testScreenKit';
import { NEURO_DOT_COLORS } from '../../../components/VisualFieldForthValley/NeuroSuiteInfo';

const VisualFieldResultsFV = ({ testData }) => {
  const {
    visualFieldForthValley: {
      results: { orientationCorrect, orientationIncorrect, missedOnceDots, missedTwiceDots, seenDots, forthValleyVisualFieldDots } = {},
    },
  } = testData;

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-evenly', gap: 24, width: '100%' }} data-testid='neuro-vf-results'>
      <VisualFieldMatrix dotMatrixFromResults={forthValleyVisualFieldDots} testProgressData={testData?.visualFieldForthValley?.results} size={430} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <Legend
          items={[
            { color: NEURO_DOT_COLORS.correct, label: `Orientation Correct: ${orientationCorrect?.length || 0}` },
            { color: NEURO_DOT_COLORS.incorrect, label: `Orientation Incorrect: ${orientationIncorrect?.length || 0}` },
            { color: NEURO_DOT_COLORS.missedOnce, label: `Not Seen Once: ${missedOnceDots?.length || 0}` },
            { color: NEURO_DOT_COLORS.missedTwice, label: `Not Seen Twice: ${missedTwiceDots?.length || 0}` },
          ]}
        />
        <strong style={{ fontSize: 15 }}>{`Total Seen: ${seenDots?.length || 0}`}</strong>
      </div>
    </div>
  );
};

export default VisualFieldResultsFV;
